import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { ProductViewModalComponent } from './product-view-modal/product-view-modal.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  gridApi: GridApi;
  columnDefs:any[];
  operations: any[];
  tempoperations: any[];
  rowData;
  advanceSearch;
  selectedRow;
  Statuslist: any = [];
  TheraputicAreaList: any =[];
  productSearch: UntypedFormGroup;
  isSettings:boolean =false;
  collapesedOrNot:boolean=false;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonservice: CommonService
  ) {

  }

  ngOnInit() {
    this.Statuslist = [
      { "value": "-1", "label": "All" },
      { "value": "1", "label": "Active" },
      { "value": "0", "label": "Inactive" }
    ]; 
    this.productSearch = new UntypedFormGroup({
      Name: new UntypedFormControl(),
      RecordStatus: new UntypedFormControl("-1"),
      Theraupetic_AreaName: new UntypedFormControl("-1"),
    });
     
    this.columnDefs = [
      {
        "headerName": "Name",
        "field": "NAME"
      },
      {
        "headerName": "Therapeutic area",
        "field": "TherapeuticName"
      },
      {
        "headerName": "Strength",
        "field": "Strength"
      },
      {
        "headerName": "Units",
        "field": "Units"
      },
      {
        "headerName": "Status",
        "field": "RecordStatus"
      }
    ];

    this.tempoperations = [ ];
    if(this.commonservice.getScreenPermission("603","V")){
      this.isSettings=true;
      this.tempoperations.push({
        "name": "View",
          "id": "View"
      });
    }
    if(this.commonservice.getScreenPermission("603","E")){
      this.isSettings=true;
      this.tempoperations.push({
        "name": "Edit",
          "id": "Edit"
      });
    }
    if(this.commonservice.getScreenPermission("603","D")){
      this.isSettings=true;
      this.tempoperations.push({
        "name": "Delete",
          "id": "Delete"
      });
    }
    if(this.commonservice.getScreenPermission("603","N")){
      this.tempoperations.push({
        "name": "Add Product",
          "id": "Add"
      });
    }
    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.advanceSearch = {
      "fields": [
        {
          "label": "Name",
          "field": "Name",
          "type": "text"
        },
        {
          "label": "Therapeutic Area",
          "field": "TherapeuticArea",
          "type": "dropdown"
        },
        {
          "label": "Status",
          "field": "Status",
          "type": "dropdown",
        }
      ]
    };
    this.GetSummary();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }
  

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const modalRef = this['self'].modalService.open(ProductViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'] }
    }
  }
  View(Record: any) {
     ;
    let modalRef = this['self'].modalService.open(ProductViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'View',
      content: { id: Record['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].setSummaryData();
    })
  }
  Add() {
    const modalRef = this['self'].modalService.open(ProductViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      content: { id: "" }
    }
    modalRef.result.then(result=>{   
      this['self'].GetSummary();
    })
  }

  Edit(Record: any) {
    let modalRef = this['self'].modalService.open(ProductViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: Record['ID'] }
    }
    modalRef.result.then(result=>{
      this['self'].GetSummary();
    })
  }
  GetSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData('api/Product/GetSummaryData').subscribe(summary => {
      this.rowData = summary
    });
    this.TheraputicAreaList = [];
    this.summaryService.GetMasterScreenData('api/Product/GetMasterScreenData').subscribe(summary => {
      this.TheraputicAreaList = summary["MasterData3"];
     this.TheraputicAreaList=  [{label:"Select",value:"-1", checked: true}].concat(this.TheraputicAreaList);
    });
  }
  getSearchData(searchobject) {
    this.summaryService.AdvanceSearch('api/Product/AdvanceSearch', searchobject).subscribe(summary => {
      this.rowData = summary;
    });

  }

  Delete(Record: any) {
    let id = Record['ID'];
    let name = Record['NAME'];
   const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
   modalRef.componentInstance.Content={ heading: 'Delete Product', custommessage: 'Are you sure you want to delete the Product ' + "'" + name+ "'" + ' ?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
   modalRef.result.then(result => {
      if(result=="okclick")
      {
        this["self"].summaryService.Delete('api/Product/Delete?RecordID=' + id).subscribe(summary => {
          if (summary["Status"] == 0) {
            this["self"].commonservice.SuccessBanner(summary.Message);
            this['self'].GetSummary();
          }
          else {
            this["self"].commonservice.ValidationBanner(summary.Message);
          }
        });
      }
 
    })


  };
  //// Advace search Functions
  SearchClear() {
    this.productSearch.patchValue({
      Name: "",
      RecordStatus: "-1",
      Theraupetic_AreaName: "-1"
    });
  }
  AdvanceSearch() {
    var formData = this.productSearch.value;
    this.getSearchData(formData);
  }
  onAdvanceSearchOperation(searchFiletrs) {
  }
}
